"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locator = void 0;
var tslib_1 = require("tslib");
var json_pointer_1 = tslib_1.__importDefault(require("json-pointer"));
var view_1 = require("@catalytic/view");
function locator(value, fromIndex) {
    return value.indexOf('{{', fromIndex);
}
exports.locator = locator;
var HANDLEBAR = /^{{(.+)}}/;
var SPLIT = /[.\[\]'"]+/;
function handlebars(eat, value, silent) {
    var _a, _b;
    var match = HANDLEBAR.exec(value);
    if (match) {
        if (silent) {
            return true;
        }
        var parts = match[1].split(SPLIT).filter(function (part) { return part.length; });
        var reference = json_pointer_1.default.compile(parts);
        var schemaReference = json_pointer_1.default.compile(parts.reduce(function (o, part) { return o.concat(['properties', part]); }, []));
        var defaultView = view_1.textView({ role: ((_a = this.options) === null || _a === void 0 ? void 0 : _a.role) || view_1.Role.READER, reference: reference, schemaReference: schemaReference }, match[0]);
        var view = (((_b = this.options) === null || _b === void 0 ? void 0 : _b.views) || {})[reference] || {};
        return eat(match[0])(tslib_1.__assign(tslib_1.__assign({}, defaultView), view));
    }
}
exports.default = handlebars;
handlebars.locator = locator;
handlebars.notInLink = false;
//# sourceMappingURL=handlebars.js.map